import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.scss']
})
export class SendNotificationComponent implements OnInit {
  formData = {
    title: '',
    body: '',
    user_id: null
  };
  public userData : any

  constructor(
    private route: ActivatedRoute,
    private apisService: ApisService,
    private toastr: ToastrService,
      private apiService : ApisService, 
        private loading : LoadingService,
          private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const routeId = this.route.snapshot.paramMap.get('id');
    this.formData.user_id = routeId ? +routeId : null; // Set user_id from route

       this.route.params.subscribe((res) => {
    const id = res['id'];
    this.userDetails(id);
      });

  }


    /*----------  Get user Details  ----------*/
    userDetails(id: any) {
      this.loading.show()
    this.apiService.userDetails(id).subscribe({
      next: (res) => {
        this.userData = res.data
        console.log(this.userData)
        this.loading.hide()
      },
      error: (err) => {
        console.log('error in fetching', err)
        this.toastr.error(
          this.translate.instant('MENU.DASHBOARD.UNEXPECTED_ERROR'),
          this.translate.instant('MENU.DASHBOARD.ERROR')
        )
        this.loading.hide()
      }
    })
  } 


  submitForm(): void {
    if (!this.formData.user_id) {
      this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.INVALID_USER_ID'),
        this.translate.instant('MENU.DASHBOARD.ERROR')
      );
      return;
    }

    const payload = {
      title: this.formData.title,
      body: this.formData.body,
      user_id: this.formData.user_id
    };

    this.apisService.SendNotification(this.formData.user_id, payload).subscribe({
  next: (res) => {
  this.toastr.success(
    this.translate.instant('MENU.DASHBOARD.NOTIFICATION_SENT_SUCCESS')
  );

  this.formData = {
    title: '',
    body: '',
    user_id: this.formData.user_id
  };
},

error: (err) => {
  console.error('Send error:', err);

  this.toastr.error(
    this.translate.instant('MENU.DASHBOARD.NOTIFICATION_SENT_ERROR')
  );
}
    });
  }
}
